import { useQuery } from "@tanstack/react-query"
import { Link } from "react-router-dom"
import { GuardianCard } from "@/components/GuardianCard"
import { getCards } from "@/api/gameApi"
import { useGuardiansPassport } from "@/features/passport/GuardiansPassportContext"

export default function CollectionTab() {
  const { collectionCards, cardsVersion, passport } = useGuardiansPassport()
  const q = useQuery({
    queryKey: ["cards", cardsVersion],
    queryFn: getCards,
  })
  const cards = q.data?.length ? q.data : collectionCards
  const activeId =
    passport?.activeCardId ?? passport?.activeCard?.id ?? null

  return (
    <div className="px-4 py-6">
      <h1 className="text-xl font-semibold text-guardians-accent">Колода</h1>
      {q.isLoading ? (
        <p className="mt-4 text-sm text-guardians-muted">Загрузка карт…</p>
      ) : (
        <ul className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3">
          {cards.map((card) => (
            <li key={card.id} className="flex justify-center">
              <Link
                to={`/play/cards/${encodeURIComponent(card.id)}`}
                className="block"
              >
                <GuardianCard
                  card={card}
                  size="sm"
                  isActive={activeId === card.id}
                />
              </Link>
            </li>
          ))}
        </ul>
      )}
      {!q.isLoading && cards.length === 0 ? (
        <p className="mt-4 text-sm text-guardians-muted">Карт пока нет</p>
      ) : null}
    </div>
  )
}
